import { tokenRevokeAtLogOutUser } from './logout-user';
import localStorageHardReset from '../helper-functions/localStorageHardReset';
import { APP_ENV, INTERCOM_ENABLED_ENVS } from '../constants/central-api';
import { isDemoMode } from '../demo/demo-mode';
import { isNewDemoMode } from '../demo-new/demo-mode';
import { signOutOfDemo } from '../demo-new/demo-lead';

/**
 * The sign-out behind "Sign Out" in the profile menus and the `/logout` route.
 * Revokes the session, shuts Intercom down and clears the stored state.
 *
 * Returns the path to show next, or `null` when the page is already being left
 * (the demos have no account session and reload into their own entry point).
 */
export function signOutOfApp(
  currentPath: string = window.location.pathname
): string | null {
  if (isNewDemoMode()) {
    // The new demo has no account session: sign out forgets the demo lead
    // and reloads into the gate.
    signOutOfDemo();
    return null;
  }
  if (isDemoMode()) {
    // The demo has no real session — "logout" just restarts the dummy demo.
    window.location.assign('/demo');
    return null;
  }
  // Not awaited: it reads the tokens and sends the server revokes
  // synchronously, so the hard reset below can't clear them first, and a slow
  // or failing revoke never holds up the local sign-out.
  void tokenRevokeAtLogOutUser();
  if (INTERCOM_ENABLED_ENVS.includes(APP_ENV)) {
    // @ts-ignore:next-line
    window.Intercom && window.Intercom('shutdown'); //shutdown intercom
  }

  localStorageHardReset();

  return currentPath === '/register' ? '/register' : '/login';
}
